import { compose, CorrectLens, lensIndex, lensProp } from "ramda";
import { Spread, SpreadAccount, SpreadSheet } from "../spread/types";

export const spreadIncomeStatementsLens: CorrectLens<
  Spread,
  SpreadSheet[]
> = compose(
  lensProp("financialTemplate"),
  lensProp("incomeStatements")
);

export const spreadBalanceSheetsLens: CorrectLens<
  Spread,
  SpreadSheet[]
> = compose(
  lensProp("financialTemplate"),
  lensProp("balanceSheets")
);

export const spreadCashFlowsLens: CorrectLens<Spread, SpreadSheet[]> = compose(
  lensProp("financialTemplate"),
  lensProp("cashFlows")
);

export const topLevelChildrenLens: CorrectLens<
  SpreadSheet[],
  SpreadAccount[]
> = compose(
  lensIndex(0),
  lensProp("node"),
  lensProp("children")
);

export const topLevelChildrenSecondPeriodLens: CorrectLens<
  SpreadSheet[],
  SpreadAccount[]
> = compose(
  lensIndex(1),
  lensProp("node"),
  lensProp("children")
);

export const spreadIncomeStatementTopLevelChildren: CorrectLens<
  Spread,
  SpreadAccount[]
> = compose(
  spreadIncomeStatementsLens,
  topLevelChildrenLens
);

export const spreadIncomeStatementTopLevelChildrenSecondPeriod: CorrectLens<
  Spread,
  SpreadAccount[]
> = compose(
  spreadIncomeStatementsLens,
  topLevelChildrenSecondPeriodLens
);

export const spreadBalanceSheetTopLevelChildren: CorrectLens<
  Spread,
  SpreadAccount[]
> = compose(
  spreadBalanceSheetsLens,
  topLevelChildrenLens
);

export const spreadBalanceSheetTopLevelChildrenSecondPeriod: CorrectLens<
  Spread,
  SpreadAccount[]
> = compose(
  spreadBalanceSheetsLens,
  topLevelChildrenSecondPeriodLens
);

export const spreadCashFlowTopLevelChildren: CorrectLens<
  Spread,
  SpreadAccount[]
> = compose(
  spreadCashFlowsLens,
  topLevelChildrenLens
);

export const spreadCashFlowTopLevelChildrenSecondPeriod: CorrectLens<
  Spread,
  SpreadAccount[]
> = compose(
  spreadCashFlowsLens,
  topLevelChildrenSecondPeriodLens
);



// WEBPACK FOOTER //
// ./src/spread/model/derivedModel/lenses.ts